import projectOptions from "src/shared/project-options";

export function thumbnail(url: string, option: any) {
  const isThumbnailActive =
    projectOptions.default.options.thumbnailOptions?.active;
  const thumbnailOptions = projectOptions.default.options.thumbnailOptions;

  const getFileRoot = (url: string) => url.substring(0, url.lastIndexOf("."));
  const getFileExtension = (url: string) => url.substring(url.lastIndexOf("."));
  const toBool = (parameter: any) => {
    if (!parameter) return false;
    return parameter;
  };
  const convertToTitleCase = (string: any) =>
    string && string.length >= 2
      ? string.charAt(0).toUpperCase() + string.substring(1).toLowerCase()
      : string;
  let thumbnailUrl = "";
  if (url && option) {
    const thumbnailActive = toBool(isThumbnailActive);
    // @ts-ignore
    const thumbnailOption = toBool(thumbnailOptions[option]);
    if (thumbnailActive && thumbnailOption) {
      const _width = toBool(thumbnailOption.width);
      const _height = toBool(thumbnailOption.height);
      const _quality = toBool(thumbnailOption.quality);
      const _crop = toBool(thumbnailOption.crop);
      const _upscale = toBool(thumbnailOption.upscale);
      thumbnailUrl =
        getFileRoot(url) +
        (_width || _height ? "_size" : "") +
        (_width ? _width : "") +
        (_height ? "x" + _height : "") +
        (_quality ? "_quality" + _quality : "") +
        (_crop ? "_crop" + convertToTitleCase(_crop) : "") +
        (_upscale ? "_upscale" + convertToTitleCase(_upscale) : "") +
        getFileExtension(url);
    } else {
      thumbnailUrl = url;
    }
  }
  return thumbnailUrl;
}
